import {
  arrayOf, extend, params, shape, string
} from '@thd-nucleus/data-sources';

export const dataModel = extend({}, {
  product: params({ itemId: string().isRequired() }).shape({
    dataSources: string(),
    itemId: string(),
    specificationGroup: arrayOf(shape({
      specTitle: string(),
      specifications: arrayOf(shape({
        specName: string(),
        specValue: string()
      }))
    }))
  })
});
